const TilesData = [
	{
		title: "+3%",
		text: "On average, local authorities increased their construction spend by 3% between 2015/16 and 2020/21",
	},
	{
		title: "+£140m",
		text: "Spending rose from £4.63 billion to £4.77 billion",
	},
	{
		title: "£28.22m",
		text: "In 2020/21, each local authority spent an average of £28.22 million on construction",
	},
];

export default TilesData;
